import { CFG_CHIP_NAV_COMPACT, CFG_NAV_GRID_WIDE_LAST } from '../../lib/configuratorChip';
import { chipAccentStyle } from '../../lib/configuratorAccent';
import { resolveConfiguratorTileHint } from '../../lib/configuratorTileHint';
import type { PimNavTile, PimSibling } from '../../lib/pimBranchUi';
import { subtypeSlugFromGroupId } from '../../lib/pimBranchUi';

type Props = {
  sectionTitle: string;
  tiles: readonly PimNavTile[];
  siblings: PimSibling[];
  activeGroupId: string | null;
  onNavigate: (groupId: string) => void;
  hapticSelection: () => void;
};

export function PimSubtypeNavigator({
  sectionTitle,
  tiles,
  siblings,
  activeGroupId,
  onNavigate,
  hapticSelection,
}: Props) {
  const activeSlug = activeGroupId ? subtypeSlugFromGroupId(activeGroupId) : '';

  return (
    <div className="mt-3">
      <p
        className="text-[10px] font-bold uppercase tracking-widest mb-3 flex items-center gap-1.5"
        style={{ color: 'var(--text-3)' }}
      >
        <span style={{ color: 'var(--cyan)' }}>◈</span>
        {sectionTitle}
      </p>
      <div className={CFG_NAV_GRID_WIDE_LAST}>
        {tiles.map((tile) => {
          const sg = siblings.find((s) => subtypeSlugFromGroupId(s.group_id) === tile.subtypeSlug);
          const active = activeSlug === tile.subtypeSlug;
          const disabled = !sg;
          const hint = sg
            ? resolveConfiguratorTileHint(
                { tile_hint: sg.tile_hint, variants_count: sg.variants_count },
                tile.hint,
              )
            : tile.hint;
          return (
            <button
              key={tile.subtypeSlug}
              type="button"
              disabled={disabled}
              title={disabled ? 'Нет вариантов в каталоге' : undefined}
              onClick={() => {
                if (!sg || active) return;
                hapticSelection();
                onNavigate(sg.group_id);
              }}
              className={CFG_CHIP_NAV_COMPACT}
              style={chipAccentStyle('protocol', active)}
            >
              <span className="text-xs font-bold leading-tight">{tile.label}</span>
              <span
                className="text-[9px] font-normal leading-tight line-clamp-2 w-full"
                style={{ color: active ? 'inherit' : 'var(--text-3)', opacity: active ? 0.85 : 1 }}
              >
                {hint}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
